import { Div, Button } from '@codesuma/baseline'
import { IDayCell } from '../../../services/calendar'
import { Occasions } from './occasions'
import { PhoneEvents } from './phone-events'
import style from './index.module.css'

// What is on the day, under its tasks on the day page's first tab: the events
// on it and the occasions it is named for. Two blocks rather than one
// interleaved list — an occasion row and an event row say different things and
// are read differently — but one section, because "what is on today" is one
// question. It stands against the margin rule the way the tasks do (see
// .happenings).
//
// Events lead. What the user has on is theirs; the name a day carries belongs
// to everyone. The same order the month's own list reads in.
//
// The two blocks are built elsewhere and handed back on the component, so the
// slide above wires their rows exactly as it did when they were separate
// sections. This adds the offer under them, and nothing else.

// Material Design "add" icon (Apache 2.0), inherits currentColor.
const PLUS_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"/></svg>'

export const Happenings = (day: IDayCell) => {
    const base = Div()
    base.addClass(style.happenings)

    const events = PhoneEvents(day)
    const occasions = Occasions(day)
    base.append(events, occasions)

    // "another" once there is something to be another of, so an empty day reads
    // as an invitation rather than as a list with nothing in it.
    const empty = !events.el.children.length && !occasions.el.children.length
    const add = Button()
    add.addClass(style.addRow, style.columnAdd, style.ruledAdd)
    add.html(`${PLUS_SVG}<span>${empty
        ? 'افزودن رویداد'
        : 'افزودن رویدادی دیگر'}</span>`)
    add.on('click', () => base.emit('add', day))
    base.append(add)

    return Object.assign(base, { events, occasions })
}
